var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.7342,
    r: 32.5,
    fill: "#0156FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9114 20.6266C26.1061 20.6266 20.5696 26.1631 20.5696 32.9684V38.0816C20.5696 39.3454 21.6767 40.3734 23.038 40.3734H24.2721C24.5995 40.3734 24.9134 40.2434 25.1448 40.0119C25.3763 39.7805 25.5063 39.4666 25.5063 39.1392V32.7919C25.5063 32.4645 25.3763 32.1506 25.1448 31.9192C24.9134 31.6877 24.5995 31.5577 24.2721 31.5577H23.1515C23.8377 26.7814 27.9475 23.0949 32.9114 23.0949C37.8752 23.0949 41.9851 26.7814 42.6713 31.5577H41.5506C41.2233 31.5577 40.9094 31.6877 40.6779 31.9192C40.4465 32.1506 40.3164 32.4645 40.3164 32.7919V40.3734C40.3164 41.7347 39.2094 42.8418 37.8481 42.8418H35.3797V41.6076H30.443V45.3101H37.8481C40.5707 45.3101 42.7848 43.096 42.7848 40.3734C44.1461 40.3734 45.2532 39.3454 45.2532 38.0816V32.9684C45.2532 26.1631 39.7166 20.6266 32.9114 20.6266Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.694b9714986b7e0c1d5c8b7bb1308296.svg";
export { ForwardRef as ReactComponent };